// HTML escaping for values interpolated into HTML that is built as a string and
// injected via document.write (the print/preview popups). Server or user data
// must be escaped so it cannot inject markup or break out of an attribute.
//
// Note: escapes quotes too (unlike the text-only helper in printDoc.js), because
// these values are placed inside attributes like src="...".
export function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// Allow only http(s) URLs where we build a URL into print HTML; anything else
// (javascript:, data:, etc.) collapses to empty so it cannot execute.
export function safeUrl(u) {
  const s = String(u == null ? "" : u).trim();
  return /^https?:\/\//i.test(s) ? s : "";
}

// For <img src>: allow http(s) and data:image/* (uploaded ID photos may be data
// URLs) but reject anything else (e.g. data:text/html, javascript:).
export function safeImageUrl(u) {
  const s = String(u == null ? "" : u).trim();
  return (/^https?:\/\//i.test(s) || /^data:image\//i.test(s)) ? s : "";
}
